import React from 'react';
import { Layout } from './components/layout';
import { Translator } from './components/translator';
import { Route, Routes } from 'react-router-dom';
import { Connection } from './fake-cdux/components/connection/connection';
import { MainViewModel } from './fake-cdux/components/activities/main-view-model';
import { PrivateRoutes } from './fake-cdux/router/private-routes';
import { URL } from './fake-cdux/router/url'
import './custom.css';
import { useLocation } from 'react-router-dom';

const App = () => {

    const location = useLocation();

    if (process.env.REACT_APP_FAKECDUX === "true" && (location.pathname === URL.LOGIN || location.pathname === URL.ACTIVITIES)) {
        return (
            <Translator>
                <Routes>
                    <Route path={URL.LOGIN} element={<Connection />} />
                    <Route element={<PrivateRoutes />}>
                        <Route path={URL.ACTIVITIES} element={<MainViewModel />} />
                        </Route>
                </Routes>
            </Translator>
        );
    } else {
        return (
            <Translator>
                <Layout />
            </Translator>
        );
    }
};

export default App;
